export default __webpack_public_path__ + "static/media/homem.c8acf377.svg";